<template>
	<div
		@click.stop="$emit('focus-on-pdf')"
		class="file-viewer display-flex flex-column flex-centerize"
		:class="{ 'is-active': isActive, 'is-focused': isFocused }"
	>
		<FileViewerIndicationIcon />
		<div class="mt-n8">Document Viewer</div>
		<div class="description">Insert link(s) to see preview</div>
	</div>
</template>

<script>
import FileViewerIndicationIcon from './assets/file-viewer-indication-icon.svg';
export default {
	name: 'FileViewerIndication',
	components: {
		FileViewerIndicationIcon,
	},
	props: {
		isActive: { type: Boolean },
		isFocused: { type: Boolean },
	},
};
</script>
<style scoped lang="scss">
.is-focused {
	border: 1px solid var(--primary-color);
}
.file-viewer {
	opacity: 0;
	width: 146px;
	height: 146px;
	cursor: pointer;
	font-size: 12px;
	border-radius: 6px;
	font-weight: medium;
	color: var(--primary-color);
	background: var(--bg-color) !important;
	box-shadow: 0px 3px 6px var(--shadow-color);

	&.is-active {
		opacity: 1;
		transition: 0.8s;
		margin: 0px 0px 0px 35px;
	}
	&:not(.is-active) {
		max-width: 0;
		position: absolute;
	}
}
.description {
	font-size: 12px;
	text-align: center;
	font-weight: normal;
	color: var(--bold-title);
}
</style>
